

/* -- Cart Overlay -- */
const cartOverlay = document.getElementById('cart-overlay');
const cartOverlayBackdrop = document.getElementById('cart-overlay-backdrop');
const closeCartButton = document.getElementById('close-cart-overlay');
const subtotal = document.getElementById('subtotal');
const cart = document.getElementById('cart');
const body = document.querySelector('body');

// Toggle cart overlay
const toggleCartOverlay = () => {
    cartOverlay.classList.toggle('hidden');
    body.classList.toggle('max-h-[100svh]');
    body.classList.toggle('overflow-hidden');
}

// Add event listeners for toggling cart overlay
document.querySelectorAll('.cart-button').forEach(button => { button.addEventListener('click', toggleCartOverlay) });
cartOverlayBackdrop.addEventListener('click', toggleCartOverlay);
closeCartButton.addEventListener('click', toggleCartOverlay);

// Extract Shopify currency code from DOM (cannot inject into JS)
const currencyCode = document.getElementById('currency-code').innerHTML;
const currencySymbol = document.getElementById('currency-symbol').innerHTML;

// Helper function for converting cent value to money with currency code
const formatMoney = (value) => {
    return `${currencySymbol}${(value/100).toFixed(2)} ${currencyCode}`;
}
// Give global access to this function for use elsewhere
document.formatMoney = formatMoney;

// Recalculates cart subtotal and applies to DOM
const updateSubtotalDom = () => {
    let newTotal = 0;
    let newQty = 0;
    
    document.querySelectorAll('.product').forEach(product => {
        const quantity = parseInt(product.querySelector('.quantity__input').value);
        newTotal += parseInt(product.getAttribute('price')) * quantity;
        newQty += quantity;
    })
    
    subtotal.innerHTML = formatMoney(newTotal);
    
    document.querySelectorAll(".cart-items-count").forEach(counter => {
        counter.innerHTML = newQty;
    })
}

// Removes product from cart via Shopify API (then recalculates cart subtotal)
const removeFromCart = (id) => {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: {
                [id]: 0
            }
        })
    })
    .then(response => {
        return response.json();
    })
    .catch((error) => {
        console.error('Error:', error);
    });
    
    document.getElementById(`prod-${id}`).remove();
    updateSubtotalDom();
}

const handleRemoveFromCart = (e) => {
    removeFromCart(e.target.getAttribute('data'));
}

// Helper function for adding event listeners to products in the cart overlay (required after refreshing DOM)
const addCartProductEventListeners = () => {
    document.querySelectorAll('.remove-button').forEach(button => { button.addEventListener('click', handleRemoveFromCart) });
    document.querySelectorAll('.quantity__button').forEach(button => { button.addEventListener('click', updateSubtotalDom) });
}
addCartProductEventListeners();

// Refreshes cart DOM from Shopify Cart API
const refreshCartDom = async () => {
    const { items } = await fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => {
        return response.json();
    })
    .catch(error => {
        console.log("Error occured whilst fetching data to refresh cart DOM:", error); 
    })
    
    // Note: May need to implement more graceful fail behaviour
    if(!items) return;
    
    let html = "";
    
    // Loop through products in the cart
    for(const key in items) {
        // Get product from Shopify API (needed for discounts to display)
        const product = await fetch(window.Shopify.routes.root + 'products/' + items[key].handle + '.js')
        .then(response => {
            return response.json();
        })
        .catch(error => {
            console.log(`Error occured whilst fetching product data for ${items[key].title} whilst refreshing cart DOM:`, error);
        })
        
        const { metafields } = await fetch(window.Shopify.routes.root + 'products/' + items[key].handle + '?view=metafields')
        .then(response => {
            return response.json();
        })
        .catch(error => {
            console.log(`Error occured whilst fetching product data for ${items[key].title} whilst refreshing cart DOM:`, error);
        })
        
        console.log(metafields);
        
        // Note: May need to implement more graceful fail behaviour
        if(!product) return;
        
        // Combine cart item and product data
        const item = {...items[key], ...product, id: items[key].id};
        
        console.log(item);
        // Add HTML for product
        html += `
        <div id="prod-${item.id}" price="${item.price}" class="product w-full flex py-8 border-b border-gray-400">
            <div class="w-[10rem] h-[14rem]">
                <img src="${item.featured_image}" alt="" srcset="${item.featured_image}&amp;width=352 352w, ${item.featured_image}&amp;width=832 832w, ${item.featured_image}&amp;width=1200 1200w, ${item.featured_image}&amp;width=1920 1920w, ${item.featured_image}&amp;width=2048 2048w" width="2048" height="3072.0000000000005" class="w-full h-full object-cover">
            </div>
            <div class="pl-8 flex flex-col justify-between flex-grow">
                <div class="w-full">
                    <h2 class="text-2xl font-bold">${metafields?.title ?? item.title}</h2>
                    <span class="text-p-sm opacity-75">${metafields?.color ? metafields.color : ""}</span>
                    <div class="text-2xl mt-4">
                        <span class="inline pt-8">${formatMoney(item.price)}</span>
                        <span class="text-red-600 inline pt-8 line-through">${item.compare_at_price ? formatMoney(item.compare_at_price) : ""}</span>
                    </div>
                </div>
                <div class="w-full flex justify-between text-2xl">
                    <button class="remove-button underline opacity-75 hover:opacity-100 -mb-2" type="button" data="${item.id}">
                        Remove
                    </button>
                    <quantity-popover>
                        <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                            <label class="visually-hidden" for="Quantity-1">
                                Quantity
                            </label>
                            <div class="quantity-popover-container">
                                <quantity-input class="quantity cart-quantity w-[calc(6.8rem+2px)] min-h-[calc(2.7rem+2px)] opacity-50 hover:opacity-100 group">
                                    <button class="quantity__button w-[2.5rem] shrink-0 flex items-center justify-center text-3xl opacity-100 group-hover:opacity-50 hover:!opacity-100" name="minus" type="button">
                                        <span class="visually-hidden">Decrease quantity for ${item.title}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus w-[1rem]" fill="none" viewBox="0 0 10 2">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                                        </svg>
                                    </button>
                                    <input class="quantity__input w-[1.8rem] shrink-0 flex items-center justify-center text-center text-2xl" data-quantity-variant-id="45281627963620" type="number" name="updates[]" value="${item.quantity}" data-cart-quantity="${item.quantity}" min="0" data-min="1" step="1" aria-label="Quantity for ${item.title}" id="Quantity-${key}" data-index="${key}">
                                    <button class="quantity__button w-[2.5rem] shrink-0 flex items-center justify-center text-3xl opacity-100 group-hover:opacity-50 hover:!opacity-100" name="plus" type="button">
                                        <span class="visually-hidden">Increase quantity for ${item.title}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus w-[1rem]" fill="none" viewBox="0 0 10 10">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                                        </svg>
                                    </button>
                                </quantity-input>
                            </div>
                        </div>
                    </quantity-popover>
                </div>
            </div>
        </div>
        `
    }
    
    console.log(html);
    
    // Replace current cart with generated HTML
    if(cart) {
        cart.innerHTML = html;
    } else {
        document.getElementById("cart-empty-text").outerHTML = `<form action="/cart" method="post" id="cart" class="w-full flex-grow overflow-y-auto scrollbar-thin flex flex-col px-8 border-b border-black"></form>`;
        document.getElementById("cart").innerHTML += html;
    }
    // Re-apply event listeners to new DOM elements
    addCartProductEventListeners();
    // Recalculate subtotal
    updateSubtotalDom();
}

const triggerButtonAnimation = async () => {
    const addToCartButton = document.getElementById('add-to-cart-button');
    const checkButton = document.getElementById('check-button');

    addToCartButton.classList.add("hidden");// = "✔";
    checkButton.classList.remove("hidden");

    setTimeout(() => {
        addToCartButton.value = "GO TO CART";
        addToCartButton.classList.remove("hidden");
        checkButton.classList.add("hidden");
        addToCartButton.setAttribute("data-action", "open-cart");
    }, 1000);

    return;
}

const productForm = document.getElementById("product-form");
const addToCart = async (id) => {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: [{
            "id": id
        }] })
    })
    .then(response => {
        return response.json();
    })
    .catch(error => {
        console.log('Error:', error);
    })
    
    console.log(res);
    
    if(res.items) {
        console.log("Add to cart response: ", res.items);
        refreshCartDom(res.items);
        //openModal("Item added to cart!");
        await triggerButtonAnimation();
        
        const checkoutButton = document.getElementById("checkout-button");
        checkoutButton.disabled = false;
        checkoutButton.classList.remove("opacity-75");

        setTimeout(toggleCartOverlay, 1000);
    }
}

// Add to cart button handlers
const handleAddToCart = (e) => {
    const action = e.target.getAttribute('data-action');
    
    switch (action) {
        case "add-to-cart":
            const id = document.getElementById("product-id").value;
            addToCart(id);
            return;
        case "open-cart":
            toggleCartOverlay();
            return;
    }
}

window.addEventListener('DOMContentLoaded', async () => {
    document.getElementById('add-to-cart-button').addEventListener('click', handleAddToCart);
})